"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  EventCatcherContext: () => EventCatcherContext,
  EventCatcherScope: () => EventCatcherScope,
  useEventCatcher: () => useEventCatcher,
  useEventCatcherContext: () => useEventCatcherContext,
  withEventCatcher: () => withEventCatcher,
  withEventScope: () => withEventScope,
  withEventScopeWithRef: () => withEventScopeWithRef
});
module.exports = __toCommonJS(src_exports);

// src/provider/EventCatcherScope.tsx
var import_react2 = require("react");

// src/wrapper/utils/validateCamelCase.ts
var fixCamelCase = (str) => {
  if (!str || str.trim() === "") {
    return "";
  }
  if (/^[a-z][a-zA-Z0-9]*$/.test(str)) {
    return str;
  }
  const words = str.replace(/([A-Z])/g, " $1").replace(/[^a-zA-Z0-9\s]/g, " ").split(/\s+/).filter(Boolean).map((word) => word.toLowerCase());
  if (words.length === 0) {
    return "";
  }
  const firstWord = words[0];
  const remainingWords = words.slice(1).map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join("");
  return firstWord + remainingWords;
};
var validateCamelCase = (str) => {
  const isLocalhost = typeof window !== "undefined" && window.location.hostname.includes("localhost");
  const isStaging = typeof window !== "undefined" && window.location.hostname.includes("staging");
  if (typeof window === "undefined" || !isLocalhost && !isStaging) {
    return;
  }
  const isCamelCase = /^[a-z][a-zA-Z0-9]*$/.test(str);
  const warningMessage = `\u{1F6A8} @repo/event-processor Warning: The component name "${str}" should be in camelCase format.
   Example: "likeButton", "templateCard", "nameInput"
   Current: "${str}"`;
  if (!isCamelCase) {
    console.warn(warningMessage);
  }
  if (isLocalhost && !isCamelCase) {
    throw new Error(warningMessage);
  }
};

// src/provider/EventCatcherContext.ts
var import_react = require("react");
var EventCatcherContext = (0, import_react.createContext)({
  trackingScope: {}
});
var useEventCatcherContext = () => (0, import_react.useContext)(EventCatcherContext);

// src/provider/EventCatcherScope.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var EventCatcherScope = ({
  page,
  module: module2,
  feature,
  children,
  scopeParameters,
  isLoggedIn
}) => {
  const { trackingScope: parentScope } = useEventCatcherContext();
  const pageFixed = page ? fixCamelCase(page) : void 0;
  const moduleFixed = module2 ? fixCamelCase(module2) : void 0;
  const featureFixed = feature ? fixCamelCase(feature) : void 0;
  const trackingScope = (0, import_react2.useMemo)(() => {
    return {
      ...parentScope,
      // Only override defined values
      ...pageFixed !== void 0 && { page: pageFixed },
      ...moduleFixed !== void 0 && { module: moduleFixed },
      ...featureFixed !== void 0 && { feature: featureFixed },
      ...scopeParameters !== void 0 && {
        scopeParameters: {
          ...parentScope.scopeParameters,
          ...scopeParameters
        }
      },
      ...isLoggedIn !== void 0 && { isLoggedIn }
    };
  }, [
    parentScope,
    pageFixed,
    moduleFixed,
    featureFixed,
    scopeParameters,
    isLoggedIn
  ]);
  const contextValue = (0, import_react2.useMemo)(() => ({ trackingScope }), [trackingScope]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EventCatcherContext.Provider, { value: contextValue, children });
};

// src/provider/withEventScope.tsx
var React = __toESM(require("react"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var withEventScope = (Component, options) => {
  const WrappedComponent = (props) => {
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(EventCatcherScope, { ...options, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Component, { ...props }) });
  };
  WrappedComponent.displayName = Component.displayName || `WithEventScope(${Component.displayName || Component.name || "Component"})`;
  return WrappedComponent;
};
var withEventScopeWithRef = (Component, options) => {
  const WrappedComponent = React.forwardRef((props, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(EventCatcherScope, { ...options, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Component, { ...props, ref }) });
  });
  WrappedComponent.displayName = Component.displayName || `WithEventScopeWithRef(${Component.displayName || Component.name || "Component"})`;
  return WrappedComponent;
};

// src/wrapper/EventCatcher.tsx
var import_react10 = __toESM(require("react"));

// src/utils/useMergeRefs.ts
var import_react3 = require("react");
var useMergeRefs = (refs) => {
  return (0, import_react3.useCallback)(
    (value) => {
      refs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    },
    [refs]
  );
};

// src/wrapper/hooks/useHasScrolled.tsx
var import_react4 = require("react");
var useHasScrolled = ({ enabled }) => {
  const [hasScrolled, setHasScrolled] = (0, import_react4.useState)(false);
  const initialScroll = (0, import_react4.useRef)(null);
  const isUserScrolling = (0, import_react4.useRef)(false);
  (0, import_react4.useEffect)(() => {
    if (!enabled || hasScrolled) {
      return;
    }
    if (initialScroll.current === null) {
      initialScroll.current = window.scrollY;
    }
    const handleUserScroll = () => {
      isUserScrolling.current = true;
    };
    const handleScroll = () => {
      if (isUserScrolling.current) {
        setHasScrolled(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("wheel", handleUserScroll);
    window.addEventListener("touchmove", handleUserScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("wheel", handleUserScroll);
      window.removeEventListener("touchmove", handleUserScroll);
    };
  }, [enabled, hasScrolled]);
  return hasScrolled;
};

// src/wrapper/hooks/useTrackClicks.tsx
var import_react5 = require("react");

// src/utils/utils.ts
function isHTMLElement(element) {
  return element instanceof HTMLElement;
}

// src/wrapper/hooks/useTrackClicks.tsx
var useTrackClicks = ({
  ref,
  shouldTrack,
  onTrackingEvent
}) => {
  const handleClick = (0, import_react5.useCallback)(
    (e) => {
      if (!shouldTrack) {
        return;
      }
      onTrackingEvent(e);
    },
    [shouldTrack, onTrackingEvent]
  );
  (0, import_react5.useEffect)(() => {
    const element = ref.current;
    if (!isHTMLElement(element)) {
      return;
    }
    element.addEventListener("click", handleClick, true);
    return () => {
      element.removeEventListener("click", handleClick, true);
    };
  }, [ref, handleClick]);
  return { handleClick };
};

// src/wrapper/hooks/useTrackVisibility.tsx
var import_react6 = require("react");
var import_useIntersectionObserver = require("@repo/react-hooks/useIntersectionObserver");
var useTrackVisibility = ({
  ref,
  shouldTrack,
  hasScrolled,
  onTrackingEvent
}) => {
  const hasBeenVisible = (0, import_react6.useRef)(false);
  const { ref: loaderRef, inView: loaderVisible } = (0, import_useIntersectionObserver.useIntersectionObserver)({
    threshold: 0.8,
    skip: !shouldTrack
  });
  const shouldTrackVisibility = hasScrolled && loaderVisible && shouldTrack;
  (0, import_react6.useEffect)(() => {
    if (!hasBeenVisible.current && ref.current && shouldTrackVisibility) {
      onTrackingEvent();
      hasBeenVisible.current = true;
    }
  }, [shouldTrackVisibility, onTrackingEvent, ref]);
  return { refCallback: loaderRef, hasBeenVisible };
};

// src/wrapper/hooks/useHandleTrackingEvent.tsx
var import_react8 = require("react");

// src/handler/useEventHandler.ts
var import_react7 = require("react");

// src/handler/cmsAnalyticsEventFilterGetter.ts
var import_env = __toESM(require("@repo/env"));
var CmsAnalyticsEventFilterGetter = class {
  static getFilters() {
    if (this.resultPromise === null) {
      this.resultPromise = fetch(
        `${import_env.default.cmsApiUrl}/api/event-filters/definitions`
      ).then((res) => res.json());
    }
    return this.resultPromise;
  }
};
CmsAnalyticsEventFilterGetter.resultPromise = null;

// src/handler/EventHandler.ts
var import_analytics = __toESM(require("@repo/analytics"));

// src/handler/filterEvent.ts
var shouldTrackEvent = (event, filters) => {
  for (const filter of filters) {
    if (eventDoesMatchFilter(event, filter)) {
      return true;
    }
  }
  return false;
};
var eventDoesMatchFilter = (event, filter) => {
  const doesMatch = (filter.page === "*" || event.page === filter.page) && (filter.feature === "*" || event.feature === filter.feature) && (filter.module === "*" || event.module === filter.module) && (filter.element === "*" || event.element === filter.element) && (filter.action === "*" || event.action === filter.action || event.interactionType === filter.action);
  return doesMatch;
};

// src/handler/utils/buildEventName.ts
var buildEventName = (event) => {
  if (event.action) {
    const parts2 = [];
    if (event.feature) {
      parts2.push(event.feature);
    }
    if (event.module) {
      parts2.push(event.module);
    }
    parts2.push(event.action);
    return parts2.join(":");
  }
  const parts = [];
  if (event.feature) {
    parts.push(event.feature);
  } else if (event.module) {
    parts.push(event.module);
  }
  if (event.element) {
    parts.push(event.element);
  } else if (event.module) {
    parts.push(event.module);
  }
  parts.push(event.action || event.interactionType || "unknown");
  if (parts.length === 1) {
    parts.unshift("unknown");
  }
  return parts.join(":");
};

// src/handler/EventHandler.ts
var isDebugEventCatcher = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const debugParam = urlParams.get("__debug_event_catcher");
  if (debugParam === "0") {
    localStorage.removeItem("__debug_event_catcher");
  } else if (debugParam) {
    localStorage.setItem("__debug_event_catcher", "true");
  }
  return window.__debug_event_catcher || !!localStorage.getItem("__debug_event_catcher") || !!debugParam;
};
isDebugEventCatcher();
var EventHandler = class {
  // Public accessors used by the application code and tests
  static get _analyticsEventFilters() {
    return this.analyticsEventFilters;
  }
  static set _analyticsEventFilters(filters) {
    this.analyticsEventFilters = filters;
  }
  static get _eventQueue() {
    return this.eventQueue;
  }
  static set _eventQueue(queue) {
    this.eventQueue = queue;
  }
  static setAnalyticsEventFilter(filters) {
    this.analyticsEventFilters = filters;
    this.consumeEvents();
  }
  static handleEvent(event) {
    this.eventQueue.push(event);
    if (isDebugEventCatcher()) {
      const eventName = buildEventName(event);
      console.log("Captured event:", eventName, event);
    }
    this.consumeEvents();
  }
  static consumeEvents() {
    if (!this._analyticsEventFilters) {
      return;
    }
    const events = this.eventQueue;
    this.eventQueue = [];
    for (const event of events) {
      const eventName = buildEventName(event);
      if (!this._analyticsEventFilters) {
        this._eventQueue.push(event);
        continue;
      }
      const shouldTrackHandledEvent = shouldTrackEvent(
        event,
        this._analyticsEventFilters
      );
      if (!shouldTrackHandledEvent) {
        continue;
      }
      if (!event.isLoggedIn) {
        continue;
      }
      import_analytics.default.track(eventName, event.parameters);
    }
  }
};
// Internal state
EventHandler.analyticsEventFilters = void 0;
EventHandler.eventQueue = [];

// src/handler/useEventHandler.ts
var useEventHandler = () => {
  (0, import_react7.useEffect)(() => {
    (async () => {
      try {
        const result = await CmsAnalyticsEventFilterGetter.getFilters();
        EventHandler.setAnalyticsEventFilter(result.results.filters);
      } catch (error) {
        EventHandler.setAnalyticsEventFilter([]);
      }
    })();
  }, []);
  const pushEvent = (event) => {
    EventHandler.handleEvent(event);
  };
  return { pushEvent };
};

// src/utils/eventContext.ts
var createEventContext = () => ({
  timestamp: (/* @__PURE__ */ new Date()).toISOString(),
  parameters: {}
});
var withScope = (ctx, scope) => {
  if (!scope) {
    return ctx;
  }
  const result = {
    ...ctx,
    page: scope.page,
    feature: scope.feature,
    module: scope.module,
    isLoggedIn: scope.isLoggedIn
  };
  if (scope.scopeParameters) {
    return {
      ...result,
      parameters: {
        ...result.parameters,
        ...scope.scopeParameters
      }
    };
  }
  return result;
};
var withComponentData = (ctx, eventCatcherOptions, componentProps, customParameters) => {
  if (!componentProps) {
    return ctx;
  }
  const name = componentProps?.name || eventCatcherOptions?.defaultName;
  const result = {
    ...ctx,
    element: name,
    action: componentProps.eventOptions?.action,
    interactionType: ctx.interactionType,
    componentName: name
  };
  if (componentProps.eventOptions?.trackingParameters) {
    return {
      ...result,
      parameters: {
        ...result.parameters,
        ...componentProps.eventOptions.trackingParameters,
        ...customParameters
      }
    };
  }
  return result;
};
var withComponentCategory = (ctx, eventCatcherOptions) => {
  if (!eventCatcherOptions) {
    return ctx;
  }
  const updatedContext = {
    ...ctx
  };
  switch (eventCatcherOptions.componentCategory) {
    case "module":
      updatedContext.module = ctx.componentName;
      updatedContext.element = void 0;
      break;
    case "feature":
      updatedContext.feature = ctx.componentName;
      updatedContext.element = void 0;
      break;
    case "element":
      updatedContext.element = ctx.componentName;
      break;
  }
  return updatedContext;
};
var withInteractionType = (ctx, typeOverride) => {
  if (!typeOverride) {
    return ctx;
  }
  return {
    ...ctx,
    interactionType: typeOverride
  };
};
var withStandardParameters = (ctx) => {
  return {
    ...ctx,
    parameters: {
      ...ctx.parameters,
      page: ctx.page,
      feature: ctx.feature,
      module: ctx.module,
      element: ctx.element,
      action: ctx.action || ctx.interactionType
    }
  };
};
var finalizeEvent = (ctx) => {
  const contextWithStdParams = withStandardParameters(ctx);
  const finalContext = {
    ...contextWithStdParams,
    page: contextWithStdParams.page || "",
    feature: contextWithStdParams.feature || "",
    module: contextWithStdParams.module || "",
    element: contextWithStdParams.element || "",
    interactionType: contextWithStdParams.interactionType || "click",
    timestamp: contextWithStdParams.timestamp || (/* @__PURE__ */ new Date()).toISOString(),
    parameters: contextWithStdParams.parameters || {}
  };
  return {
    page: finalContext.page,
    feature: finalContext.feature,
    module: finalContext.module,
    element: finalContext.element || "",
    interactionType: finalContext.interactionType,
    action: finalContext.action,
    timestamp: finalContext.timestamp,
    parameters: finalContext.parameters,
    isLoggedIn: finalContext.isLoggedIn
  };
};

// src/wrapper/hooks/useHandleTrackingEvent.tsx
var useHandleTrackingEvent = (trackingScope, componentProps, eventCatcherOptions) => {
  const { pushEvent } = useEventHandler();
  const handleTrackingEvent = (0, import_react8.useCallback)(
    (interactionType, trackingParameters) => {
      let eventContext = createEventContext();
      eventContext = withScope(eventContext, trackingScope);
      eventContext = withComponentData(
        eventContext,
        eventCatcherOptions,
        componentProps,
        trackingParameters
      );
      eventContext = withComponentCategory(eventContext, eventCatcherOptions);
      if (interactionType) {
        eventContext = withInteractionType(eventContext, interactionType);
      }
      eventContext = withStandardParameters(eventContext);
      const trackedEvent = finalizeEvent(eventContext);
      pushEvent(trackedEvent);
    },
    [trackingScope, componentProps, eventCatcherOptions, pushEvent]
  );
  return {
    handleTrackingEvent
  };
};

// src/wrapper/hooks/useEventCatcher.tsx
var import_react9 = require("react");
var useEventCatcher = ({
  name
} = {}) => {
  const { trackingScope } = useEventCatcherContext();
  const { handleTrackingEvent } = useHandleTrackingEvent(
    trackingScope,
    { name: name || trackingScope.module || "unknown" },
    { componentCategory: "module" }
  );
  const fireCustomEvent = (0, import_react9.useCallback)(
    (action, trackingParameters) => {
      handleTrackingEvent(action, trackingParameters);
    },
    [handleTrackingEvent]
  );
  return {
    fireCustomEvent
  };
};

// src/wrapper/EventCatcher.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var withEventCatcher = (Component, eventCatcherOptions) => {
  const displayName = Component.displayName || Component.name || "Component";
  const WrappedWithEventCatcher = import_react10.default.forwardRef(
    (componentProps, _forwardedRef) => {
      const fixedName = componentProps.name ? fixCamelCase(componentProps.name) : "unknown";
      if (fixedName) {
        validateCamelCase(fixedName);
      }
      componentProps = {
        ...componentProps,
        name: fixedName
      };
      const shouldTrack = {
        show: false,
        showScrolled: false,
        click: true,
        ...eventCatcherOptions?.shouldTrack,
        ...componentProps.eventOptions?.shouldTrack
      };
      const { trackingScope } = useEventCatcherContext();
      const internalRef = (0, import_react10.useRef)(null);
      const hasScrolled = useHasScrolled({
        enabled: shouldTrack.showScrolled
      });
      const { handleTrackingEvent } = useHandleTrackingEvent(
        trackingScope,
        componentProps,
        eventCatcherOptions
      );
      const onClickTrackingEventHandler = (0, import_react10.useCallback)(
        (e) => {
          const path = e.composedPath();
          const trackedElements = path.filter(
            (el) => el instanceof Element && el.hasAttribute("data-event-catcher")
          );
          if (trackedElements.length > 0 && trackedElements[0] === internalRef.current) {
            handleTrackingEvent("click");
          }
        },
        [handleTrackingEvent]
      );
      (0, import_react10.useEffect)(() => {
        if (internalRef.current) {
          internalRef.current.setAttribute("data-event-catcher", "true");
        }
      }, []);
      useTrackClicks({
        ref: internalRef,
        shouldTrack: shouldTrack.click,
        onTrackingEvent: onClickTrackingEventHandler
      });
      const onShowTrackingEventHandler = (0, import_react10.useCallback)(() => {
        handleTrackingEvent("show");
      }, [handleTrackingEvent]);
      const { refCallback } = useTrackVisibility({
        ref: internalRef,
        shouldTrack: shouldTrack.show || shouldTrack.showScrolled,
        hasScrolled: shouldTrack.showScrolled ? hasScrolled : true,
        onTrackingEvent: onShowTrackingEventHandler
      });
      const combinedRef = useMergeRefs([
        refCallback,
        internalRef,
        _forwardedRef
      ]);
      const { eventOptions: _eventOptions, ...restProps } = componentProps;
      return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Component, { ref: combinedRef, ...restProps });
    }
  );
  WrappedWithEventCatcher.displayName = `WithEventCatcher(${displayName})`;
  return WrappedWithEventCatcher;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  EventCatcherContext,
  EventCatcherScope,
  useEventCatcher,
  useEventCatcherContext,
  withEventCatcher,
  withEventScope,
  withEventScopeWithRef
});
